
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"45.465","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h45.465v52H0z","data-name":"長方形 1215"}})])]),_c('g',{attrs:{"clip-path":"url(#a)","data-name":"グループ 693"}},[_c('path',{attrs:{"fill":"#ff9d00","d":"M35.622 31.349a70.241 70.241 0 001.461-2.7 18.856 18.856 0 001.143-2.392l.01-.024a18.931 18.931 0 001.29-6.905A19.549 19.549 0 0019.763.001 19.555 19.555 0 000 19.33a18.883 18.883 0 001.3 6.9l.01.026a19.334 19.334 0 001.144 2.395c4.7 9.256 13.692 20.747 15.3 22.467l.038.039a1.9 1.9 0 00.157.154 2.747 2.747 0 003.641 0 1.484 1.484 0 00.157-.154l.038-.039c.532-.57 1.879-2.223 3.6-4.494a11.587 11.587 0 0110.237-15.275","data-name":"パス 806"}}),_c('path',{attrs:{"fill":"#fff","d":"M19.763 27.293a7.964 7.964 0 118.14-7.961 8.051 8.051 0 01-8.14 7.961","data-name":"パス 807"}}),_c('path',{attrs:{"fill":"#ff9d00","d":"M36.4 33.868a9.235 9.235 0 00-9.065 9.065 8.929 8.929 0 00.094.937 9.044 9.044 0 108.971-10","data-name":"パス 808"}}),_c('path',{attrs:{"fill":"#fff","d":"M41.246 41.32h-3.232v-3.23a1.615 1.615 0 10-3.23 0v3.23h-3.231a1.616 1.616 0 000 3.232h3.232v3.23a1.615 1.615 0 103.23 0v-3.23h3.232a1.616 1.616 0 100-3.232","data-name":"パス 809"}})])])
          )
        }
      }
    